module.exports = __webpack_public_path__ + "img/whatdoyouwant.c93780f.png";